// extracted by mini-css-extract-plugin
export var addButton = "_o6-0";
export var border = "_o6-8";
export var check = "_o6-h";
export var danger = "_o6-6";
export var dropdownContainer = "_o6-1";
export var editModalBody = "_o6-j";
export var footerContainer = "_o6-i";
export var fullWidth = "_o6-a";
export var hide = "_o6-9";
export var icon = "_o6-3";
export var input = "_o6-7";
export var inputFlex = "_o6-b";
export var inputWrapper = "_o6-c";
export var manualFocus = "_o6-5";
export var optionButton = "_o6-4";
export var pillWrapper = "_o6-e";
export var pointer = "_o6-2";
export var showOverflow = "_o6-f";
export var tagsFlex = "_o6-d";
export var xButton = "_o6-g";